import { render } from "./BaseProgressbar.vue?vue&type=template&id=5e81fbfa&scoped=true"
const script = {}

import "./BaseProgressbar.vue?vue&type=style&index=0&id=5e81fbfa&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\music_player\\music_player_sj\\music_player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e81fbfa"]])

export default __exports__